import { Component, OnInit,  Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-onboarding-banner',
    templateUrl: './onboarding-banner.component.html',
    standalone: true,
  imports: [
    CommonModule,
    TranslateModule
  ]
})
export class OnboardingBannerComponent implements OnInit {

  @Input() currentStep: number;
  constructor() { }

  ngOnInit(): void {
  }

}
